<!-- <span class="d-flex f-small align-items-center gap-2">Showing  -->
    <div [style.width]="'10rem'">
        <app-customised-single-select  [controls]="form.controls" controlName="rowNum" [options]="options"></app-customised-single-select>
    </div>
<!-- </span> -->